module.exports = __webpack_public_path__ + "static/img/pic43.298a12a1.png";